import { render, staticRenderFns } from "./cube.vue?vue&type=template&id=fe89c748&scoped=true"
import script from "./cube.vue?vue&type=script&lang=js"
export * from "./cube.vue?vue&type=script&lang=js"
import style0 from "./cube.vue?vue&type=style&index=0&id=fe89c748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c696e2a027b626094c1ef68c77647e95/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe89c748",
  null
  
)

export default component.exports